module.exports = __webpack_public_path__ + "static/media/children-walking-pink.eb721f0f.png";